<button (click)="onButtonClick()">
  <svg-icon src="/assets/icons/icons-user-copy.svg"></svg-icon>
</button>
